import { Button } from 'components/Button';
import { TextInput } from 'components/Inputs/TextInput';
import { Snackbar } from 'components/Snackbar';
import { useLoader } from 'hooks/utilHooks';
import React, { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { AlertColor, Link, Stack, Typography } from '@mui/material';
import { useTutorUserPlan } from 'context';
import { ICouponValues, TutorUserPlanService } from 'services/tutor-user-plan.service';

interface Props {
  disabled?: boolean;
}

interface ISnackbar {
  message: string | null;
  variant?: AlertColor | undefined;
  duration?: number;
}

export const CouponInput: React.FC<Props> = ({ disabled }) => {
  const { setValue, control } = useFormContext();
  const { loading } = useLoader();
  const [couponValues, setCouponValues] = useState<ICouponValues>();
  const [snackbar, setSnackbar] = useState<ISnackbar>({
    message: '',
    variant: 'info',
  });

  // FIXME: CouponInput don't work in different context

  const handleRemoveCoupon = () => {
    setValue('ticket', '');
    setCouponValues(undefined);
  };

  const [ticket, plan] = useWatch({
    control,
    name: ['ticket', 'plan'],
  });

  const applyVoucher = () => {
    if (!ticket || !plan) {
      return;
    }

    applyCoupon();
  };

  const applyCoupon = async () => {
    if (!ticket || !plan) {
      return;
    }

    try {

      await TutorUserPlanService.getCouponByName({
        ticketName: ticket,
        planId: plan,
      }).then(setCouponValues);

      setSnackbar({
        message: `Cupom ${ticket} aplicado!`,
        variant: 'success',
        duration: 6000,
      });
    } catch (reason) {
      const { message } = reason as Error;

      setSnackbar({
        message,
        variant: 'error',
        duration: 6000,
      });
    } finally {
     
    }
  };

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} alignItems="center">
        <TextInput
          required
          name="ticket"
          id="ticket"
          label="CUPOM"
          onChange={({ target: { value } }) => {
            setValue('ticket', (value ?? '').trim().toUpperCase());
          }}
          InputProps={{
            endAdornment: (
              <Link
                display={ticket ? 'block' : 'none'}
                underline="none"
                onClick={handleRemoveCoupon}
                sx={{ cursor: 'pointer' }}
              >
                Remover
              </Link>
            ),
          }}
          inputProps={{ maxLength: 64 }}
        />

        <Button
          sx={{ height: 24 }}
          disabled={!ticket || loading || disabled}
          // onClick={applyCoupon}
          onClick={applyVoucher}
        >
          Aplicar
        </Button>
      </Stack>

      {Boolean(couponValues?.discountValue) ? (
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          pr={13}
          pl={2}
        >
          <Typography fontSize={14} fontWeight={700}>
            Desconto
          </Typography>

          <Typography color="#2E7D32" fontSize={14} fontWeight={400}>
            -{couponValues?.discountValue}
          </Typography>
        </Stack>
      ) : null}

      {snackbar.message ? (
        <Snackbar
          text={snackbar.message}
          snackbarOpen={true}
          setSnackbarOpen={() => {
            setSnackbar({
              message: '',
            });
          }}
          autoHideDuration={snackbar.duration}
          severityType={snackbar.variant}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        />
      ) : null}
    </Stack>
  );
};
